export const isDevelopment =
  process.env.NEXT_PUBLIC_BUILD_ENV === 'development';
